import { makeStyles } from '@material-ui/core'
import React from 'react'
import CustomLabel from './CustomLabel'
const useStyles = makeStyles((theme) => ({
  label: {
    // color: 'white',

    [theme.breakpoints.up('md')]: {
      //
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: '16px',
      lineHeight: '20px',
      fontWeight: 600,
    },
  },
}))

export default function CustomTypography({ label }) {
  const classes = useStyles()
  return <CustomLabel label={label} className={classes.label} />
}
